import { useState, useEffect, useCallback } from 'react';

export const useKeyPress = (targetKey: string, ctrlKey = false, callbackOnUp: Function | null = null, callbackOnDown: Function | null = null) => {
  const [keyPressed, setKeyPressed] = useState(false);

  const downHandler = useCallback(
    (event: KeyboardEvent) => {
      if (event.ctrlKey === ctrlKey && event.key === targetKey) {
        event.preventDefault();
        setKeyPressed(true);
        callbackOnDown && callbackOnDown();
      }
    },
    [callbackOnDown, ctrlKey, targetKey]
  );

  const upHandler = useCallback(
    (event: KeyboardEvent) => {
      if ((event.ctrlKey === ctrlKey && event.key === targetKey) || event.key === targetKey) {
        setKeyPressed(false);
        callbackOnUp && callbackOnUp();
      }
    },
    [callbackOnUp, ctrlKey, targetKey]
  );

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [downHandler, upHandler]);

  return keyPressed;
};
